import theme from '../../styles/themes/default.theme'

const styles = {
  container: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },

  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    textAlign: 'left'
  }
}

export default styles
